import dayjs, { type Dayjs } from 'dayjs';
import { RegionalOverviewFilterType, buildFilter, type Filter } from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewProperties } from 'querys/regional-overview/regional-overview.query.models';

const parseRange = (value: unknown): [Dayjs, Dayjs] | undefined => {
  if (!Array.isArray(value) || value.length !== 2) return undefined;
  const [begin, end] = value as [Dayjs, Dayjs];
  if (!begin || !end) return undefined;
  return [begin.startOf('day'), end.endOf('day')];
};

export const buildBloomingFilter = (): Filter =>
  buildFilter<RegionalOverviewProperties>({
    type: RegionalOverviewFilterType.BLOOMING,
    translatable: false,
    freeform: true,
    getValues: () => [],
    matches: (feature, value) => {
      const range = parseRange(value);
      if (!range) return true;
      const blooming = feature.properties?.blooming_date;
      if (!blooming) return false;
      const bloomingDate = dayjs(blooming);
      const [begin, end] = range;
      return (bloomingDate.isAfter(begin) || bloomingDate.isSame(begin)) && (bloomingDate.isBefore(end) || bloomingDate.isSame(end));
    }
  });
